CropperController.$inject = ['$scope', '$q', 'alerts', '$uibModalInstance', 'params'];

/* @ngInject */
function CropperController($scope, $q, alerts, $uibModalInstance, params) {
    var vm = this;
    vm.title = 'Editar ' + params.title;
    vm.loading = false;

    var API = params.API;

    vm.src = params.src;
    vm.model = null;

    var outputOptions = params.output || {};

    vm.options = {
        viewport: dimensionsFromRatio(params.ratio, Math.max(200, (outputOptions.width || 1) / 2)),
        output: {
            size: dimensionsFromRatio(params.ratio, outputOptions.width || 300),
            format: outputOptions.format || 'png',
        }
    };

    $scope.updateClientImage = function (files) {
        var reader = new FileReader();
        $scope.$apply(function () {
            vm.loading = true;
            vm.src = null;
        });
        reader.onload = function (e) {
            $scope.$apply(function () {
                vm.loading = false;
                vm.src = e.target.result;
            });
        };
        reader.readAsDataURL(files[0]);
    };

    vm.close = function () {
        $uibModalInstance.close(false);
    };
    vm.submit = function () {
        alerts.code().then(format).then(save);
    };

    function dimensionsFromRatio(ratio, width) {
        return {
            width: width,
            height: Math.floor(width / ratio)
        };
    }

    function format(code) {
        var formData = new FormData();
        if (vm.model !== null) {
            formData.append(params.id, vm.model);
            return {
                params: {
                    code: code
                },
                formData: formData
            };
        } else {
            return null;
        }
    }


    function save(data) {
        vm.loading = true;

        params.API.withHttpConfig({
            transformRequest: angular.identity
        }).customPOST(data.formData, null, data.params, _.extend({
            'Content-Type': function () {
                return undefined;
            }
        }, data.headers)).then(function (res) {
            $uibModalInstance.close(res);
        })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
    }

}

export default CropperController;